import { AppStates } from '../states';
import { createSelector } from '@ngrx/store';

export const selectLanguage = (state: AppStates) => state.translationState.selectedLanguage;
export const selectLanguageJson = (state: AppStates) => state.translationState.languageJson;
